Date.prototype.format = function(format)
{
  var o = {
    "M+" : this.getMonth()+1, //month
    "d+" : this.getDate(),    //day
    "h+" : this.getHours(),   //hour
    "m+" : this.getMinutes(), //minute
    "s+" : this.getSeconds(), //second
    "q+" : Math.floor((this.getMonth()+3)/3),  //quarter
    "S" : this.getMilliseconds() //millisecond
  }
  if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
    (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)if(new RegExp("("+ k +")").test(format))
    format = format.replace(RegExp.$1,
      RegExp.$1.length==1 ? o[k] :
        ("00"+ o[k]).substr((""+ o[k]).length));
  return format;
}
let utils={};
utils.cloneObj = function (obj) {
    let newObj = {};
    if (obj instanceof Array) {
        newObj = [];
    }
    if(obj != null){
        for (var key in obj) {
            var val = obj[key];
            newObj[key] = (typeof(val) === 'object' && val !=null) ? utils.cloneObj(val): val;
        }
    }
    return newObj;
};
utils.loading = function(){
	return {
		time: new Date().getTime(),
		close:function(callback){
			let s=new Date().getTime()-this.time;
			if(s>=1000){
				callback();
			}
			else{
				setTimeout(callback,1000-s)
			}
			console.log('time',new Date().getTime()-this.time)
		}
	}
};
export default utils;


// WEBPACK FOOTER //
// ./src/utils/util.js